import { render, staticRenderFns } from "./TransferModalForm.vue?vue&type=template&id=4909baf5"
import script from "./TransferModalForm.vue?vue&type=script&lang=js"
export * from "./TransferModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports